export const classesOnScroll = (function($) {

    var $DOM = {};
    var lastKnownScrollY = 0;
    var currentScrollY = 0;
    var ticking = false;

    function init() {

        $DOM.header = $("#main-header");
        if(!$DOM.header.length) {
            return;
        }

        eventListener();

    }

    // Throttle function utility
    function throttle(func, timeFrame) {
        var lastTime = 0;
        return function() {
            var now = new Date();
            if (now - lastTime >= timeFrame) {
                func();
                lastTime = now;
            }
        };
    }

    // detect onScroll
    function onScroll() {
        currentScrollY = window.pageYOffset;
        requestTick();
    }

    // request ticking to use animationFrame
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(update);
        }
        ticking = true;
    }

    // update classes onScroll
    function update() {
        // Manage header autohide
        if (currentScrollY < lastKnownScrollY) {
            pin();
        } else if ((currentScrollY > lastKnownScrollY) && currentScrollY > 100) {
            unpin();
        }

        lastKnownScrollY = currentScrollY;
        ticking = false;
    }

    // show header menu
    function pin() {
        if ($DOM.header.hasClass('header-unpin')) {
            $DOM.header.removeClass('header-unpin');
            $DOM.header.addClass('header-pin');
        }
    }

    // hide header menu
    function unpin() {
        if ($DOM.header.hasClass('header-pin') || !$DOM.header.hasClass('header-unpin')) {
            $DOM.header.removeClass('header-pin');
            $DOM.header.addClass('header-unpin');
        }
    }

    // add eventListener to page scroll
    function eventListener() {
        document.addEventListener('scroll', throttle(onScroll, 30), false);
    }

    return {
        init: init
    }

})(jQuery);
